<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip || 'Toggle Fullscreen'"
    (click)="toggleFullscreen()"
>
    <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_outline:arrows-pointing-out'"
        *ngIf="!isFullscreen"
    ></mat-icon>
    <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_outline:arrows-pointing-in'"
        *ngIf="isFullscreen"
    ></mat-icon>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
</ng-template>
